import React from 'react';

const MobileLayout = ({ children, styles }) => {
    const [navigationButton, thoughtEditor, actionButtons] = children;

    return (
        <div style={styles.composePage.mobile.container}>
            <div style={styles.composePage.mobile.header}>
                {navigationButton}
                <div style={styles.composePage.mobile.buttonContainer}>
                    {actionButtons}
                </div>
            </div>
            
            <div style={styles.composePage.mobile.textareaContainer}>
                {thoughtEditor}
            </div>
        </div>
    );
};

export default MobileLayout; 